import createComponent, { ComponentProps } from '../utils/createComponent';
export type SidenavHeaderProps = ComponentProps;

const SidenavHeader = createComponent({ name: 'SidenavHeader' });

export default SidenavHeader;
